module.exports = __webpack_public_path__ + "static/fa-solid-900-acf50f59802f20d8b45220eaae532a1c.ttf";